var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h5',{attrs:{"id":"api-error"},domProps:{"innerHTML":_vm._s(_vm.$t('error.api'))}})
}
var staticRenderFns = []

export { render, staticRenderFns }